import { render, staticRenderFns } from "./BasketDetailDialog.vue?vue&type=template&id=0838063c&scoped=true&"
import script from "./BasketDetailDialog.vue?vue&type=script&lang=js&"
export * from "./BasketDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./BasketDetailDialog.vue?vue&type=style&index=0&id=0838063c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0838063c",
  null
  
)

export default component.exports